var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\uADF8\\uB8F9_21458",
    "data-name": "\\uADF8\\uB8F9 21458",
    transform: "translate(-567 -233)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\uC0AC\\uAC01\\uD615_27942",
    "data-name": "\\uC0AC\\uAC01\\uD615 27942",
    width: 24,
    height: 24,
    transform: "translate(567 233)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "noun-reset-3257974",
    d: "M90.006,58.368l-1.588-3.084a.7.7,0,1,1,1.25-.646l.829,1.616h0A9.259,9.259,0,0,1,107.751,57.6a.7.7,0,0,1-1.349.386,7.854,7.854,0,0,0-14.668-1.061l2.3-.8h0a.7.7,0,0,1,.464,1.328l-3.646,1.293a.883.883,0,0,1-.225,0,.7.7,0,0,1-.625-.372Zm19.262,6.618-1.581-3.119h0a.7.7,0,0,0-.864-.316l-3.639,1.279h0a.7.7,0,0,0,.464,1.328l2.311-.808a7.833,7.833,0,0,1-14.675-1.1.7.7,0,0,0-1.349.379,9.231,9.231,0,0,0,17.253,1.356l.829,1.623h0a.7.7,0,0,0,1.25-.625Z",
    transform: "translate(480.16 184.857)",
    fill: "#343a40",
    stroke: "#343a40",
    strokeWidth: 0.2
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterIcon);
export default __webpack_public_path__ + "static/media/FilterIcon.729206597bf3e1c4790d8ce7bb6dc4f0.svg";
export { ForwardRef as ReactComponent };